export default __webpack_public_path__ + "static/media/vnnic-logo.2ed83698.png";